import React from "react";
import { Helmet } from "react-helmet";

const NotFound: React.FC = () => {
  return (
    <div className="page" style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "60vh",
    }}>
        <Helmet>
            <title>404 | IsarRanger</title>
        </Helmet>
      <h1>404</h1>
      <p>Seite nicht gefunden</p>
    </div>
  );
}

export default NotFound;